export interface Message {
    level: 'info' | 'warn' | 'success' | 'error';
    message: string;
    details: string | undefined;
    detailsTimestampUtc?: string | undefined;
    publisherName?: string | undefined;
    publisherId?: string | undefined;
    source?: string | undefined;
    icon?: string | undefined;
    time: string;
}

export function parseMessages(data: any): Message[] {
    if (!data || !Array.isArray(data)) {
        return [];
    }
    return data.map((msg: any) => {
        let icon: string | undefined;
        let level = msg.level || msg.Level;
        switch (level) {
            case 'Info':
                icon = 'pi pi-info-circle';
                break;
            case 'Success':
                icon = 'pi pi-check-circle';
                break;
            case 'Warning':
                icon = 'pi pi-exclamation-triangle';
                break;
            case 'Error':
                icon = 'pi pi-times-circle';
                break;
            default:
                icon = undefined;
        }
        return {
            level: level === 'Error' ? 'error' : level === 'Warning' ? 'warn' : level.toLowerCase(),
            message: msg.message || msg.Message || '',
            details: msg.detailsMessage || msg.DetailsMessage || undefined,
            detailsTimestampUtc: msg.detailsTimestampUtc || msg.DetailsTimestampUtc || undefined,
            publisherName: msg.publisherName || msg.PublisherName || undefined,
            publisherId: msg.publisherId || msg.PublisherId || undefined,
            source: msg.source || msg.Source || undefined,
            type: msg.typeName || msg.TypeName || undefined,
            // The framework serialises TimestampUtc; linked-device health reports firstSeenUtc instead.
            time: msg.timestampUtc || msg.TimestampUtc || msg.firstSeenUtc || msg.timeStamp || msg.TimeStamp || undefined,
            icon
        };
    });
}

export function filterMessagesByLevel(messages: Message[], levels: ('info' | 'warn' | 'success' | 'error')[]): Message[] {
    let results = messages.filter(msg => levels.includes(msg.level));
    results.sort((a, b) => {
        const levelOrder = { 'error': 0, 'warn': 1, 'info': 2, 'success': 3 };
        if (levelOrder[a.level] !== levelOrder[b.level]) {
            return levelOrder[a.level] - levelOrder[b.level];
        }
        return a.message.localeCompare(b.message);
    });
    return results;
}